import React from "react";
import { useHistory } from "react-router-dom";
import { PieChartUtils } from "./ChartUtils";

export default function DataTableTool(props) {
  const history = useHistory();

  let labelCol = props.label.length / 2;
  let labelLimit = [];
  for (let i = 0; i < labelCol; i++) {
    labelLimit.push({ count: i === 0 ? 0 : i * 2 });
  }

  let defaultColors = ["#a6cee3", "#1f78b4", "#b2df8a", "#33a02c", "#fb9a99", "#e31a1c", "#fdbf6f", "#ff7f00", "#cab2d6", "#6a3d9a", "#ffff99", "#b15928"];

  const colorFunc = (i) => {
    return props.color === undefined ? { backgroundColor: defaultColors[i], width: "5px" } : { backgroundColor: props.color[i], width: "5px" };
  };

  const legendFunc = (data) => {
    console.log(data);
    let total = 0;
    props.data.map((d) => {
      return (total = total + parseInt(d));
    });
    return (
      <tr style={{ fontSize: "9px" }}>
        {(props.label[data + 0] !== undefined) & (props.label[data + 0] !== null) & (props.label[data + 0] !== "") ? (
          <>
            <th style={colorFunc(data + 0)}>&nbsp;</th>
            <td
              style={props.routeObject != undefined ? { cursor: "pointer" } : { cursor: "default" }}
              onClick={() =>
                props.routeObject != undefined ? history.push({ pathname: "/dashboard/table", state: { selected: props.label[data + 0], object: props.routeObject } }) : null
              }
            >
              {props.label[data + 0]}
            </td>
            <td>
              {props.noFixed ? props.data[data + 0] : parseFloat(props.data[data + 0])}
              <br />
              {"(%" + parseFloat(((props.data[data + 0] / total) * 100).toFixed(1)) + ")"}
            </td>
          </>
        ) : null}
        {(props.label[data + 1] !== undefined) & (props.label[data + 1] !== null) & (props.label[data + 1] !== "") ? (
          <>
            <th style={colorFunc(data + 1)}>&nbsp;</th>
            <td
              style={props.routeObject != undefined ? { cursor: "pointer" } : { cursor: "default" }}
              onClick={() =>
                props.routeObject != undefined ? history.push({ pathname: "/dashboard/table", state: { selected: props.label[data + 1], object: props.routeObject } }) : null
              }
            >
              {props.label[data + 1]}
            </td>
            <td style={{ fontSize: "9px" }}>
              {props.noFixed ? props.data[data + 1] : parseFloat(props.data[data + 1])}
              <br />
              {"(%" + parseFloat(((props.data[data + 1] / total) * 100).toFixed(1)) + ")"}
            </td>
          </>
        ) : null}
      </tr>
    );
  };

  const legendFuncSingle = (data) => {
    console.log(data);
    let total = 0;
    props.data.map((d) => {
      return (total = total + parseInt(d));
    });
    return (
      <tr style={{ fontSize: "9px" }}>
        {(props.label[data + 0] !== undefined) & (props.label[data + 0] !== null) & (props.label[data + 0] !== "") ? (
          <>
            <th style={colorFunc(data + 0)}>&nbsp;</th>
            <td
              style={props.routeObject != undefined ? { cursor: "pointer" } : { cursor: "default" }}
              onClick={() =>
                props.routeObject != undefined ? history.push({ pathname: "/dashboard/table", state: { selected: props.label[data + 0], object: props.routeObject } }) : null
              }
            >
              {props.label[data + 0]}
            </td>
            <td>
              {props.noFixed ? props.data[data + 0] : parseFloat(props.data[data + 0])}
              <br />
              {"(%" + parseFloat(((props.data[data + 0] / total) * 100).toFixed(1)) + ")"}
            </td>
          </>
        ) : null}
      </tr>
    );
  };

  return (
    <div className="d-flex flex-wrap gap-2 m-2">
      <div className="flex-grow-1 d-flex justify-content-center align-items-center">
        <table className="table table-sm table-bordered mb-0">
          <tbody>
            {props.single == undefined
              ? props.label.map((_d, i) => {
                  return legendFuncSingle(i);
                })
              : labelLimit.map((d) => {
                  return legendFunc(d.count);
                })}
          </tbody>
        </table>
      </div>
      {props.showChart !== false && (
        <div className="flex-grow-1 d-flex justify-content-center align-items-center">{props.showChart != false && <PieChartUtils data={props.allData} />}</div>
      )}
    </div>
  );
}
